import * as UAParser from 'ua-parser-js';
import * as LocalStorage from 'dg-web-shared/lib/LocalStorage';
import { Items } from 'dg-web-shared/lib/LocalStorage';
import { v1 as uuidv1 } from 'uuid';
import { Store } from 'dg-web-shared/lib/Flux';
import { GeolocationState } from '../common/state/GeolocationState';
import { RELEASE_ID } from 'dg-web-shared/common/utils/release';
import { logActionShared } from 'dg-web-shared/lib/utils/ActionLog.ts';

const agent = new UAParser.UAParser().getResult();
export const device = {
    ...agent,
    width:
        typeof window !== 'undefined' && typeof window.screen !== 'undefined'
            ? window.screen.width
            : 0,
    height:
        typeof window !== 'undefined' && typeof window.screen !== 'undefined'
            ? window.screen.height
            : 0,
};

function getOrSetUUID() {
    const token = LocalStorage.getStringItem(Items.deviceUuid);
    if (token) {
        return token;
    }
    const uuid = uuidv1();
    LocalStorage.setStringItem(Items.deviceUuid, uuid);
    return uuid;
}

export const DEVICE_UUID = getOrSetUUID();

export const logAction = (
    store: Store | null,
    name: string,
    payload: unknown = null,
): string => {
    const url = '/ui-api/customer-account/flux-action';
    const geo = store != null ? GeolocationState.get(store) : null;
    const body = {
        action: name,
        payload: payload,
        location: geo != null ? geo.currentLocation : null,
        device: device,
        appVersion: RELEASE_ID,
        uuid: DEVICE_UUID,
    };
    logActionShared(url, body, name);
    return 'logged-action';
};
